// ABOUTME: Context and hook for the sidebar open/closed state
// ABOUTME: The provider lives in SidebarProvider.tsx; this file has no components

import { createContext, useContext } from "react"

export interface SidebarContextProps {
  isSidebarOpen: boolean
  toggleSidebar: () => void
}

export const SidebarContext = createContext<SidebarContextProps | undefined>(undefined)

export const useSidebarContext = () => {
  const context = useContext(SidebarContext)
  if (!context) {
    throw new Error("useSidebarContext must be used within a SidebarProvider")
  }
  return context
}

export default SidebarContext
